import React from "react";
import { useNavigate } from "react-router-dom";
import { ContextLanguage } from "../../../context/Context.Language";
import { TEXT_CONTACT_US } from "../../../utils/useConstants";
import { useIsMobile } from "../../../utils/useIsMobile";
import {
  STYLE_BANNER_BLUE,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_PADDING_READING,
} from "../../../utils/useStyle";
import ProgramGoBack from "../../task/render/Program.GoBack";
import ProgramClickBack from "../../task/functions/Program.ClickBack";

const ContactBanner = () => {
  const { language } = React.useContext(ContextLanguage);
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  return (
    <div className="relative overflow-hidden ">
      <div
        className={`${STYLE_BANNER_BLUE} mt-16 md:mt-[72px] relative  `}
        style={{
          backgroundImage: isMobile
            ? `url(/images/bg_contactus_mb.png)`
            : `url(/images/bg_blue_contactus.svg)`,
          // backgroundImage: `url(/images/bg_blue_contactus.svg)`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "bottom",
          backgroundSize: "cover",
        }}
      >
        <img
          style={{
            backgroundClip: "content-box",
          }}
          src={"/images/contactus_icon_banner.png"}
          className={` border-none  h-[197.31px] md:h-img_banner mx-auto absolute bottom-[4px] md:bottom-0 left-1/2 transform -translate-x-1/2 rounded-b-[24px] `}
        />

        <div
          className={`${STYLE_PADDING_READING} ${STYLE_MAX_WIDTH_DESKTOP} px-4 md:px-6 `}
        >
          <ProgramGoBack
            onClick={() => {
              ProgramClickBack(navigate);
              // const past = sessionStorage.getItem("redirect-back-to");
              // if (past === "/ContactUsTH" || past === "/ContactUsEN") {
              //   navigate("/");
              // } else if (past) {
              //   navigate(past);
              // } else {
              //   navigate("/");
              // }
            }}
            marginarrow="md:ml-9"
            title={TEXT_CONTACT_US[language]}
            textcolor={`${
              language === "TH"
                ? " text-30-th md:text-40-th "
                : " text-30 md:text-40 "
            }`}
            absolute={`${
              language === "EN"
                ? "left-[25%] md:left-1/2 md:transform md:-translate-x-1/2"
                : "left-1/2 transform -translate-x-1/2"
            }`}
          />
        </div>
      </div>
    </div>
  );
};

export default ContactBanner;
